module.exports = __webpack_public_path__ + "resources/img/main_banner_cloud06.21dfa14ab5b09ce49305fe3a546c6e1a.png";